export default __webpack_public_path__ + "static/media/music_open.bce8bfb2.svg";